import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

import Button from './Button';

const FloatingAssessmentCTA = ({ isVisible = true }) => {
  const [isHidden, setIsHidden] = useState(false);
  const [showMobileCTA, setShowMobileCTA] = useState(false);
  const location = useLocation();

  // Hide on quiz-related pages
  const hiddenPaths = ['/edad-real-assessment-quiz', '/quiz-results-dashboard'];
  const shouldHide = hiddenPaths?.includes(location?.pathname);

  useEffect(() => {
    setIsHidden(shouldHide);
  }, [shouldHide]);

  // Scroll listener for mobile CTA visibility
  useEffect(() => {
    const handleScroll = () => {
      // Show mobile CTA when user has scrolled down more than 100vh (past hero section)
      const scrollThreshold = window.innerHeight;
      setShowMobileCTA(window.scrollY > scrollThreshold);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isVisible || isHidden) return null;

  return (
    <>
      {/* Desktop floating button (always visible when scrolling) */}
      <div className="hidden md:block fixed bottom-6 right-6 z-40 md:bottom-8 md:right-8">
        <Link to="/edad-real-assessment-quiz" aria-label="Evalúa tu edad real - Test gratuito de 5 minutos">
          <Button
            variant="default"
            size="lg"
            className="bg-accent hover:bg-accent/90 text-accent-foreground shadow-card-elevated hover-scale rounded-full px-6 py-4 md:px-8 md:py-5"
            iconName="ClipboardList"
            iconPosition="left"
            iconSize={20}
          >
            <span className="font-body-semibold text-sm md:text-base">
              Evalúa tu Edad Real
            </span>
          </Button>
        </Link>
      </div>

      {/* Mobile bottom-center variant (only when scrolled past hero) */}
      {showMobileCTA && (
        <div className="md:hidden fixed bottom-4 left-4 right-4 z-40">
          <Link to="/edad-real-assessment-quiz" className="block" aria-label="Descubre tu edad real - Test gratuito de 5 minutos">
            <Button
              variant="default"
              size="lg"
              fullWidth
              className="bg-accent hover:bg-accent/90 text-accent-foreground shadow-card-elevated hover-scale rounded-lg py-4"
              iconName="ClipboardList"
              iconPosition="left"
              iconSize={20}
            >
              <span className="font-body-semibold text-base">
                Descubre tu Edad Real Ahora
              </span>
            </Button>
          </Link>
        </div>
      )}
    </>
  );
};

export default FloatingAssessmentCTA;